import classNames from 'classnames';
import React, { useCallback } from 'react';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { AssetsCollectionNavItem } from 'const';
import { intlGet } from 'utils/intlGet';
import { AssetsCollectionNavBarProps } from './models';
import styles from './styles.module.scss';

const AssetsCollectionNavIcons: Record<AssetsCollectionNavItem, IconType> = {
  [AssetsCollectionNavItem.IMAGES]: IconType.IMAGE,
  [AssetsCollectionNavItem.REFERENCE_CITATIONS]: IconType.REFERENCE_CITATION,
  [AssetsCollectionNavItem.LAYOUTS]: IconType.LAYOUT,
  [AssetsCollectionNavItem.TEXTS]: IconType.TEXT,
};

const EDITOR_TOOLBAR_TOOLTIP_PATH = 'EditorToolbar.Tooltip';

const AssetsCollectionTooltipText: Record<AssetsCollectionNavItem, () => string> = {
  [AssetsCollectionNavItem.IMAGES]: () => intlGet(EDITOR_TOOLBAR_TOOLTIP_PATH, 'Images'),
  [AssetsCollectionNavItem.REFERENCE_CITATIONS]: () => intlGet(EDITOR_TOOLBAR_TOOLTIP_PATH, 'ReferenceCitations'),
  [AssetsCollectionNavItem.LAYOUTS]: () => intlGet(EDITOR_TOOLBAR_TOOLTIP_PATH, 'Layouts'),
  [AssetsCollectionNavItem.TEXTS]: () => intlGet(EDITOR_TOOLBAR_TOOLTIP_PATH, 'TextComponents'),
};

const AssetsCollectionNavBar: React.FunctionComponent<AssetsCollectionNavBarProps> = (props) => {
  const { navItems, disabledItems, activeItem, onChange, dataTestId = 'assetsCollectionNavbar' } = props;

  const onItemChange = useCallback(
    (navItem: AssetsCollectionNavItem) => (): void => {
      onChange(navItem);
    },
    [onChange],
  );

  return (
    <div className={styles.AssetsNavBar} data-testid={dataTestId}>
      {
        navItems.map((navItem, index) => {
          const isActive = activeItem === navItem;
          const isDisabled = disabledItems.includes(navItem);

          return (
            <AccessibleDiv
              key={navItem}
              className={classNames(
                styles.icon,
                {
                  [styles.active]: isActive,
                  [styles.disabled]: isDisabled,
                },
              )}
              onClick={isDisabled ? (): void => {} : onItemChange(navItem)}
              data-tooltip={AssetsCollectionTooltipText[navItem]()}
              data-testid={`${dataTestId}-button${index}`}
            >
              <Icon type={AssetsCollectionNavIcons[navItem]} size="sm" color={isActive ? 'secondary' : 'primary'} />
            </AccessibleDiv>
          );
        })
      }
    </div>
  );
};

export default AssetsCollectionNavBar;
